import { Page } from "../../../models/cores/Page.model";
import { CreateUserRequestDto } from "../../../models/dtos/CreateUseRequest.dto";
import { Dropdown } from "../../../models/cores/Dropdown.model";
import { EmployeeBasicDto } from "../../../models/dtos/EmployeeBasic.dto";
import { EmployeeListDto } from "../../../models/dtos/EmployeeList.dto";
import { EmployeeDto } from "../../../models/dtos/Employee.dto";
import { EmployeeFilterRequestDto } from "../../../models/dtos/ProjectContainer.dto";
import { EmployeeSearchSummaryDto } from "../../../models/dtos/EmployeeSearchSummary.dto";
import { UserChangePassDto } from "../../../models/dtos/UserChangePass.dto";
import axiosCustom from "../../../utils/axiosInstance";

const API_BASE_URL: string = "/hrm/employees";

export const employeeService = {
  create: async (createEmployee: CreateUserRequestDto) => {
    const res = await axiosCustom.post<CreateUserRequestDto>(`${API_BASE_URL}`, createEmployee);
    return res.data;
  },
  updateEmployee: async (userId: string, payload: Partial<EmployeeDto>) => {
    const response = await axiosCustom.put(`${API_BASE_URL}/${userId}`, payload);
    return response.data;
  },
  search: async (keyword?: string, page = 0, size = 10, emFilter?: EmployeeFilterRequestDto): Promise<Page<EmployeeListDto>> => {
    const res = await axiosCustom.post<Page<EmployeeListDto>>(`${API_BASE_URL}/search`, emFilter, { params: { keyword, page, size } });
    return res.data;
  },
  summary: async (keyword?: string, emFilter?: EmployeeFilterRequestDto): Promise<EmployeeSearchSummaryDto> => {
    const res = await axiosCustom.post<EmployeeSearchSummaryDto>(`${API_BASE_URL}/search/summary`, emFilter, { params: { keyword } });
    return res.data;
  },
  getEmployeeBasic: async (userId: string): Promise<EmployeeBasicDto> => {
    const res = await axiosCustom.get<EmployeeBasicDto>(`${API_BASE_URL}/basic/${userId}`);
    return res.data;
  },
  getEmployee: async (userId: string): Promise<EmployeeDto> => {
    const res = await axiosCustom.get<EmployeeDto>(`${API_BASE_URL}/${userId}`);
    return res.data;
  },
  updateMyProfile: async (userId: string, payload: Partial<EmployeeDto>) => {
    const response = await axiosCustom.put(`${API_BASE_URL}/${userId}`, payload);
    return response.data;
  },
  uploadEmployeeAvatar: async (userId: string, file: File): Promise<EmployeeDto> => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axiosCustom.put<EmployeeDto>(`${API_BASE_URL}/${userId}/upload-avatar`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },
  uploadMyAvatar: async (file: File): Promise<EmployeeDto> => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axiosCustom.put<EmployeeDto>(`${API_BASE_URL}/me/upload-avatar`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },
  changeMyPass: async (changePass: UserChangePassDto): Promise<string> => {
    const response = await axiosCustom.put<string>(`${API_BASE_URL}/me/change-pass`, changePass);
    return response.data;
  },
  getEmployeeDropdownList: async (): Promise<Dropdown[]> => {
    const res = await axiosCustom.get<Dropdown[]>(`${API_BASE_URL}/dropdown-list`, {});
    return res.data;
  },
};
